import { defineSlotRecipe } from '@chakra-ui/react/styled-system';
import { anatomy } from '@zag-js/image-cropper';

const imageCropperSlotRecipe = defineSlotRecipe({
  className: 'image-cropper',
  slots: anatomy.keys(),
  base: {
    root: {
      position: 'relative',
      backgroundColor: 'background/secondary',
    },
    viewport: {
      // position: relative; overflow: hidden set inline by Zag.js
      height: '100%',
      width: 'fit-content',
    },
    image: {
      // position and transform set inline by Zag.js
      userSelect: 'none',
      pointerEvents: 'none',
      height: '100%',
      width: 'auto',
    },
    selection: {
      // position: absolute; top/left/width/height set inline by Zag.js via --crop-* CSS vars
      borderWidth: '1',
      borderStyle: 'solid',
      borderColor: 'border/regular',
      boxSizing: 'border-box',
      boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)', // overlay outside selection; clipped by viewport overflow:hidden
      _hover: {
        cursor: 'grab',
        _active: {
          cursor: 'grabbing',
        },
      },
    },
    handle: {
      // Structural position, cursor, and edge-handle sizing set inline by Zag.js
      // Corner handles: visible 8×8px squares
      '&[data-position="nw"], &[data-position="ne"], &[data-position="sw"], &[data-position="se"]': {
        width: '8',
        height: '8',
        backgroundColor: 'border/regular',
      },
    },
    grid: {
      // position: absolute; inset set inline by Zag.js
      borderColor: 'border/regular',
      opacity: 0.5,
      '&[data-axis="horizontal"]': {
        borderBlockStartWidth: '1',
        borderBlockStartStyle: 'solid',
        borderBlockEndWidth: '1',
        borderBlockEndStyle: 'solid',
      },
      '&[data-axis="vertical"]': {
        borderInlineStartWidth: '1',
        borderInlineStartStyle: 'solid',
        borderInlineEndWidth: '1',
        borderInlineEndStyle: 'solid',
      },
    },
  },
});

export default imageCropperSlotRecipe;
